import { notifyApiSuccess } from '@/v2/notifications'

export function tournamentRoundId(values: Record<string, unknown>): string | number {
  return values.id as string | number
}

export function notifySuccess(): void {
  notifyApiSuccess('Successfully updated.')
}
